import { faTrash, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, CardBody, CardFooter, CardHeader } from 'reactstrap'
import { setNewFormFields } from 'store/Forms/actions'
import { renderRightSidebarBody } from './formFunctions'

function RightSidebar({ field, setShowRightSidebar, setField }) {
  const { newFormFields } = useSelector((store) => store.form)
  const dispatch = useDispatch()

  const [tempFieldState, setTempFieldState] = useState({ ...field })

  const handleChange = (name, value) => {
    setTempFieldState((prev) => ({ ...prev, [name]: value }))
  }

  const updateFieldValue = (fieldId, property, value) => {
    setTempFieldState((prev) => ({ ...prev, [property]: value }))
  }

  const deleteField = () => {
    const updatedFormFields = newFormFields.filter(
      (element) => element.index !== field.index
    )

    dispatch(setNewFormFields(updatedFormFields))
    setShowRightSidebar(false)
    setField(null)
  }

  const updateField = () => {
    const currentIndex = newFormFields.findIndex(
      (element) => element.index === field.index
    )

    if (currentIndex !== -1) {
      const updatedFormFields = [...newFormFields]
      updatedFormFields[currentIndex] = { ...field, ...tempFieldState }

      dispatch(setNewFormFields(updatedFormFields))
    }

    setShowRightSidebar(false)
    setField(null)
  }

  return (
    <div className='position-sticky w-25' style={{ top: '3rem' }}>
      <Card className=''>
        <CardHeader className='bg-info d-flex align-items-center justify-content-between'>
          <p className='text-capitalize text-white font-weight-bold'>
            {field.type}
          </p>
          <FontAwesomeIcon
            icon={faXmark}
            size='lg'
            className='text-white'
            role='button'
            onClick={() => {
              setShowRightSidebar(false)
              setField(null)
            }}
          />
        </CardHeader>
        <CardBody className='right-sidebar-body scrollbar'>
          {renderRightSidebarBody(field, handleChange, updateFieldValue)}
        </CardBody>
        <CardFooter>
          <SubmitModalButton customFn={updateField}></SubmitModalButton>
          <button onClick={deleteField} className='btn btn-danger mx-2'>
            <FontAwesomeIcon icon={faTrash} />
          </button>
          <button
            onClick={() => {
              setShowRightSidebar(false)
              setField(null)
            }}
            className='btn btn-secondary'
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </CardFooter>
      </Card>
    </div>
  )
}

export default RightSidebar
